module.exports = __webpack_public_path__ + "pc/img/about-global-person04.ecb2ab2f.png";